import { render, staticRenderFns } from "./PainelPublico.vue?vue&type=template&id=6e9e7909&scoped=true"
import script from "./PainelPublico.vue?vue&type=script&lang=js"
export * from "./PainelPublico.vue?vue&type=script&lang=js"
import style0 from "./PainelPublico.vue?vue&type=style&index=0&id=6e9e7909&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9e7909",
  null
  
)

export default component.exports